export interface EligibleCheckForSummary {
  id: string;
  name: string;
  type?: string;
}

export interface ApplicantForCheckSummary {
  id: string;
  eligible_monitoring_checks: readonly EligibleCheckForSummary[];
}

export interface EligibleCheckTypeGroup {
  name: string;
  checkIds: string[];
  applicantCount: number;
}

export function groupEligibleChecksByType(
  applicants: ApplicantForCheckSummary[]
): EligibleCheckTypeGroup[] {
  const groups = new Map<
    string,
    { checkIds: string[]; applicants: Set<string> }
  >();
  applicants.forEach((applicant) => {
    applicant.eligible_monitoring_checks.forEach((check) => {
      const group = groups.get(check.name) ?? {
        checkIds: [],
        applicants: new Set<string>(),
      };
      group.checkIds.push(check.id);
      group.applicants.add(applicant.id);
      groups.set(check.name, group);
    });
  });
  return Array.from(groups.entries())
    .map(([name, group]) => ({
      name,
      checkIds: group.checkIds,
      applicantCount: group.applicants.size,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export interface EligibleCheckTypeOption {
  id: string;
  name: string;
}

export function eligibleCheckTypeFilterOptions(
  applicants: readonly ApplicantForCheckSummary[],
  accountOptions: readonly { type: string; label: string }[] = []
): EligibleCheckTypeOption[] {
  const byType = new Map<string, string>();
  accountOptions.forEach((option) => {
    if (option.type) {
      byType.set(option.type, option.label || option.type);
    }
  });
  applicants.forEach((applicant) => {
    applicant.eligible_monitoring_checks.forEach((check) => {
      const checkType = check.type || check.name;
      if (!byType.has(checkType)) {
        byType.set(checkType, check.name || checkType);
      }
    });
  });
  return Array.from(byType.entries())
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}

export function formatEligibleCheckTypeLabel(
  name: string,
  applicantCount: number
): string {
  return `${name} (${applicantCount})`;
}
